/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { OffsetDateTime } from "@freightsimple/time/branded-types";

import { mapValues } from "../runtime";
/**
 * Lean row for the carrier Timeline tab --- full snapshot is fetched per-meeting on demand.
 * @export
 * @interface CarrierMeetingSummary
 */
export interface CarrierMeetingSummary {
  /**
   *
   * @type {string}
   * @memberof CarrierMeetingSummary
   */
  carrierMeetingId: string;
  /**
   *
   * @type {string}
   * @memberof CarrierMeetingSummary
   */
  title?: string | null;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof CarrierMeetingSummary
   */
  meetingDate?: OffsetDateTime | null;
  /**
   *
   * @type {string}
   * @memberof CarrierMeetingSummary
   */
  summaryShort?: string | null;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof CarrierMeetingSummary
   */
  createdAt?: OffsetDateTime | null;
  /**
   *
   * @type {string}
   * @memberof CarrierMeetingSummary
   */
  createdBy?: string | null;
}

/**
 * Check if a given object implements the CarrierMeetingSummary interface.
 */
export function instanceOfCarrierMeetingSummary(
  value: object,
): value is CarrierMeetingSummary {
  if (!("carrierMeetingId" in value) || value["carrierMeetingId"] === undefined)
    return false;
  return true;
}

export function CarrierMeetingSummaryFromJSON(
  json: any,
): CarrierMeetingSummary {
  return CarrierMeetingSummaryFromJSONTyped(json, false);
}

export function CarrierMeetingSummaryFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CarrierMeetingSummary {
  if (json == null) {
    return json;
  }
  return {
    carrierMeetingId: json["carrierMeetingId"],
    title: json["title"] == null ? undefined : json["title"],
    meetingDate: json["meetingDate"] == null ? undefined : json["meetingDate"],
    summaryShort:
      json["summaryShort"] == null ? undefined : json["summaryShort"],
    createdAt: json["createdAt"] == null ? undefined : json["createdAt"],
    createdBy: json["createdBy"] == null ? undefined : json["createdBy"],
  };
}

export function CarrierMeetingSummaryToJSON(json: any): CarrierMeetingSummary {
  return CarrierMeetingSummaryToJSONTyped(json, false);
}

export function CarrierMeetingSummaryToJSONTyped(
  value?: CarrierMeetingSummary | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    carrierMeetingId: value["carrierMeetingId"],
    title: value["title"],
    meetingDate: value["meetingDate"],
    summaryShort: value["summaryShort"],
    createdAt: value["createdAt"],
    createdBy: value["createdBy"],
  };
}
